export function forEachNode(nodes, fn) {
    nodes?.forEach(fn)
}